const { register, verifiedEmail } = require('./operations');

module.exports = {
  register,
  verifiedEmail,
};
